import React from "react";
import PropTypes from "prop-types";

const PaymentMethodRadioItem = ({
  element,
  allowRemove,
  handleRemove,
  showRelink,
  handleRelink,
  decorator,
  disabled,
}) => (
  <div className="flex">
    <span className={`self-start ${disabled ? "text-gray-400" : ""}`}>
      {`${element.institution} - ${element.nickname} (**${element.account_number_last_four})`}
    </span>
    {!showRelink && allowRemove && (
      <span
        className="ml-4 text-red-400 self-end hover:underline"
        onClick={(e) => {
          if (disabled) { return; }
          handleRemove(element.id);
          e.stopPropagation();
          e.preventDefault();
          return false;
        }}
      >
        Delete
      </span>
    )}
    {showRelink && (
      <span
        className="ml-4 self-end flex items-center cursor-pointer"
        onClick={(e) => {
          handleRelink(element.id);
          e.stopPropagation();
          e.preventDefault();
          return false;
        }}
      >
        <i className="fas fa-exclamation-triangle text-red-500 mr-2 text-sm" />
        <span className="text-red-400 self-end hover:underline">
          Relink Required
        </span>
      </span>
    )}
    {decorator && decorator()}
  </div>
);

PaymentMethodRadioItem.propTypes = {
  // element: PropTypes.shape({
  //   type: PropTypes.string,
  //   nickname: PropTypes.string.isRequired,
  //   accountNumberLastFour: PropTypes.string.isRequired,
  //   isDefault: PropTypes.bool
  // }).isRequired,
  allowRemove: PropTypes.bool,
  handleRemove: PropTypes.func,
  showRelink: PropTypes.bool,
  handleRelink: PropTypes.func,
  disabled: PropTypes.bool,
};

PaymentMethodRadioItem.defaultProps = {
  allowRemove: true,
  showRelink: false,
  handleRemove: () => {},
  handleRelink: () => {},
  disabled: false,
};

export default PaymentMethodRadioItem;
